import { render, staticRenderFns } from "./zpxz.vue?vue&type=template&id=4b0ff982&scoped=true&"
import script from "./zpxz.vue?vue&type=script&lang=js&"
export * from "./zpxz.vue?vue&type=script&lang=js&"
import style0 from "./zpxz.vue?vue&type=style&index=0&id=4b0ff982&scoped=true&lang=css&"
import style1 from "./zpxz.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ff982",
  null
  
)

export default component.exports